import { EPlatformFeature } from '@enums/campaign.enum';

const WARNINGS_BASE_KEY = 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.platformStep.warnings';

export const PLATFORM_FEATURE_WARNINGS: Partial<Record<EPlatformFeature, string[]>> = {
  [EPlatformFeature.instagramStory]: [
    `${WARNINGS_BASE_KEY}.instagramStory.authenticatedCreatorsOnly`,
    `${WARNINGS_BASE_KEY}.instagramStory.first60SecondsOnly`,
  ],
};
